import { HomePage, WelcomePage } from './';

export default {
  path: '',
  childRoutes: [{ path: '/', component: WelcomePage, isIndex: true }],
};
